import {
  videoStore,
  set_Video1_DisplayData,
  set_Video1_DisplayAngle,
  set_Video1_DisplaySRC,
  set_Video_idx,
  set_PlayMode
} from "../state/videoSlice";
import {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import visualAngle from "../data/visualAngle.json";
import { resolveVideoData } from "../Utils/DataProcess2";

const VideoDetails = ({
  filteredvideo,
  checkedItems,
  setCheckedItems,
  index,
  setLoading,
}) => {
  // 處理勾選項目
  const handleCheckboxChange = (index) => {
    setCheckedItems((prevCheckedItems) =>
      prevCheckedItems.map((item, i) => (i === index ? !item : item)),
    );
  };

  const handleDisplayVideoClick = async (video) => {
    setLoading(true);
    const resolveVideo = await resolveVideoData(video);
    videoStore.dispatch(set_Video1_DisplayData(resolveVideo));
    setLoading(false);
  };

  return (
    <tr
      className="filmroom_list_ball"
      ball={index + 1}
      onClick={() => handleDisplayVideoClick(filteredvideo)}
    >
      <td>
        <label onClick={(event) => event.stopPropagation()}>
          <input
            type="checkbox"
            className=""
            checked={checkedItems[index] || false}
            onChange={() => handleCheckboxChange(index)}
          />
          <span></span>
        </label>
      </td>
      <td>
        {filteredvideo.year} {filteredvideo.hitter} VS {filteredvideo.pitcher}
        <br />
        {filteredvideo.details}
      </td>
      <td>{filteredvideo.length}</td>
    </tr>
  );
};

const RightSidebar = forwardRef((props, ref) => {
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const sidebarRef = useRef(null);

  const handleSelectChange = (event) => {
    const selectedView = event.target.value;
    videoStore.dispatch(set_Video1_DisplayAngle(selectedView));
    videoStore.dispatch(set_Video1_DisplaySRC(visualAngle[selectedView]));
    setCheckedItems(Array(filteredVideos.length).fill(false));
  };

  useEffect(() => {
    setFilteredVideos(props.videos);
  }, [props.videos]);

  useEffect(() => {
    setCheckedItems(Array(filteredVideos.length).fill(false));
  }, [filteredVideos]);

  useImperativeHandle(ref, () => ({
    handleButtonClick: (view) => {
      const selectElement = document.getElementById("list_top");
      selectElement.value = view;
      setCheckedItems(Array(filteredVideos.length).fill(false));
    },
  }));

  const clearForm = () => {
    const formElement = sidebarRef.current;
    if (formElement) {
      formElement
        .querySelectorAll('input[type="checkbox"]')
        .forEach((checkbox) => (checkbox.checked = false));
      formElement
        .querySelectorAll('input[type="text"]')
        .forEach((input) => (input.value = ""));
      formElement
        .querySelectorAll("select")
        .forEach((select) => (select.selectedIndex = 0));
      formElement
        .querySelectorAll('input[type="range"]')
        .forEach((range) => (range.value = range.max / 2));
    }
    setCheckedItems(Array(filteredVideos.length).fill(false));
  };

  const downLoadVideo = () => {
    checkedItems.forEach(async (checked, idx) => {
      if (checked) {
        const { src, video_object_key } = await resolveVideoData(
          filteredVideos[idx],
        );
        try {
          const response = await fetch(src + video_object_key, {
            mode: "cors",
          });
          const blob = await response.blob();
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = video_object_key || "video.mp4";
          link.click();
          document.body.removeChild(link);
        } catch (err) {
          console.log("DownLoad Error", err);
        }
      }
    });
  };

  const downloadAll = async () => {
    for (let it of filteredVideos) {
      const { video_object_key, src } = await resolveVideoData(it);
      downLoadVideo(src, video_object_key);
    }
  };

  return (
    <div className="filmroom_videolist" ref={sidebarRef}>
      <div className="filmroom_list_top">
        <div className="list_top_title">
          {filteredVideos && <span>{filteredVideos.length} 項 搜尋結果</span>}
        </div>
        <select
          className="list_top"
          id="list_top"
          onChange={handleSelectChange}
        >
          {Object.keys(visualAngle).map((angleType, index) => (
            <option key={index}>{angleType}</option>
          ))}
        </select>
      </div>
      <table className="filmroom_list">
        <thead>
          <tr>
            <th>選取</th>
            <th>影片資訊</th>
            <th>時間點</th>
          </tr>
        </thead>
      </table>
      <div className="filmroom_list_container">
        <table className="filmroom_list">
          <tbody>
            {filteredVideos &&
              filteredVideos.map((filteredvideo, index) => (
                <VideoDetails
                  key={index}
                  filteredvideo={filteredvideo}
                  checkedItems={checkedItems}
                  index={index}
                  setCheckedItems={setCheckedItems}
                  setLoading={props.setLoading}
                />
              ))}
          </tbody>
        </table>
      </div>
      <div className="clear"></div>
      <div className="filmroom_videoctl">
        <div className="list_bottom_title">
          已選擇 {Object.values(checkedItems).filter(Boolean).length} 部影片
        </div>
        <div className="btn_blue_filmroom" onClick={downLoadVideo}>
          下載
        </div>
        <div className="btn_white_filmroom" onClick={downloadAll}>
          全部下載
        </div>
        <div className="btn_white_filmroom" onClick={clearForm}>
          清除
        </div>
      </div>
    </div>
  );
});

export default RightSidebar;
